/* lefelin — Header « Classique affiné »
   1) verre dépoli au scroll (classe lf-scrolled sur .m-header)
   2) dropdowns lf-nav : ouverture au survol avec grâce 200 ms + tap mobile/tablette
   3) méga-menu : accordéon catégories + swap du panneau mosaïque produits */
(function () {
  if (window.__lfHeaderV2) return;
  window.__lfHeaderV2 = true;

  function init() {
    /* ---- verre dépoli au scroll ---- */
    var header = document.querySelector('.m-header');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('lf-scrolled', (window.scrollY || document.documentElement.scrollTop) > 16);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var canHover = window.matchMedia('(hover: hover)').matches;

    /* ---- le panneau est ancré left:0 sur son item de nav : s'il déborde du
       viewport à droite (ex. « Transport pour chat », dernier gros menu), on le
       décale vers la gauche juste avant l'ouverture ---- */
    var clampMenu = function (h) {
      var menu = h.querySelector('.lf-menu');
      if (!menu) return;
      menu.style.left = '';
      var r = menu.getBoundingClientRect(); /* visibility:hidden garde le layout */
      var over = r.right - (window.innerWidth - 16);
      if (over > 0) {
        var maxShift = Math.max(0, r.left - 16);
        menu.style.left = -Math.min(over, maxShift) + 'px';
      }
    };
    window.addEventListener('resize', function () {
      document.querySelectorAll('.lf-menu').forEach(function (m) {
        m.style.left = '';
      });
    });

    /* ---- dropdowns : survol avec grâce + tap quand pas de hover ---- */
    document.querySelectorAll('.lf-hasmenu').forEach(function (h) {
      var t;
      var trigger = h.querySelector('.lf-nl');
      var open = function () {
        clearTimeout(t);
        clampMenu(h);
        h.classList.add('open');
      };
      var close = function () {
        clearTimeout(t);
        t = setTimeout(function () {
          h.classList.remove('open');
        }, 80);
      };
      h.addEventListener('mouseenter', open);
      h.addEventListener('mouseleave', close);
      if (trigger && !canHover) {
        trigger.addEventListener('click', function (e) {
          if (!h.classList.contains('open')) {
            e.preventDefault();
            document.querySelectorAll('.lf-hasmenu.open').forEach(function (o) {
              o.classList.remove('open');
            });
            open();
          }
        });
      }
    });

    /* ---- méga-menu : accordéon + panneau mosaïque ---- */
    document.querySelectorAll('.lf-menu').forEach(function (menu) {
      var cards = menu.querySelectorAll('.lf-m-mosaic');
      menu.querySelectorAll('.lf-m-catwrap').forEach(function (wrap) {
        var activate = function () {
          menu.querySelectorAll('.lf-m-catwrap').forEach(function (w) {
            w.classList.toggle('active', w === wrap);
          });
          if (cards.length) {
            var card = menu.querySelector('.lf-m-mosaic[data-key="' + wrap.dataset.key + '"]');
            if (card) {
              cards.forEach(function (c) {
                c.classList.toggle('is-active', c === card);
              });
            }
          }
        };
        wrap.addEventListener('mouseenter', activate);
        wrap.querySelector('.lf-m-cat').addEventListener('focus', activate, true);
      });
      /* sous-collections : leur propre panneau mosaïque au survol */
      menu.querySelectorAll('.lf-m-sub a[data-key]').forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          var card = menu.querySelector('.lf-m-mosaic[data-key="' + a.dataset.key + '"]');
          if (card) {
            cards.forEach(function (c) {
              c.classList.toggle('is-active', c === card);
            });
          }
        });
      });
    });
    /* ---- tiroir mobile : accordéon (exclusif entre frères du même niveau) ---- */
    document.querySelectorAll('.lf-mm-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = btn.closest('.lf-mm-haschildren');
        var isOpen = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen);
        if (isOpen) {
          var siblings = item.parentElement.children;
          Array.prototype.forEach.call(siblings, function (sib) {
            if (sib !== item && sib.classList.contains('lf-mm-haschildren')) {
              sib.classList.remove('open');
              var sb = sib.querySelector(':scope > .lf-mm-row .lf-mm-toggle');
              if (sb) sb.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

